
import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

export function StaffTableSkeleton() {
  return (
    <Card className="p-4">
      <div className="space-y-4">
        <Skeleton className="h-10 w-full" />
        {[1, 2, 3].map(i => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    </Card>
  );
}
